import { render, staticRenderFns } from "./messageGai.vue?vue&type=template&id=77029ff7&scoped=true"
import script from "./messageGai.vue?vue&type=script&lang=js"
export * from "./messageGai.vue?vue&type=script&lang=js"
import style0 from "./messageGai.vue?vue&type=style&index=0&id=77029ff7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77029ff7",
  null
  
)

export default component.exports